import { observer } from "mobx-react-lite";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";

const ProjectHome = ({ project }) => {
  const navigate = useNavigate();

  const cards = [
    {
      icon: "🔬", title: "Screening", subtitle: "",
      desc: "可视化工作流编排 · 自动化筛选",
      action: () => navigate("screening/"),
    },
    {
      icon: "🧬", title: "Compounds", subtitle: "",
      desc: "Dashboard & 子表管理",
      action: () => navigate("compounds/"),
    },
    {
      icon: "📊", title: "Activity", subtitle: "",
      desc: "数据透视表",
      action: () => navigate("compounds/?sub=activity"),
    },
    {
      icon: "📦", title: "DMPK / Assets", subtitle: "",
      desc: "DMPK 数据",
      action: () => navigate("compounds/?sub=dmpk"),
    },
    {
      icon: "👥", title: "Members", subtitle: "",
      desc: "成员管理",
      action: () => navigate("settings/"),
    },
    {
      icon: "ℹ️", title: "Project Info", subtitle: "",
      desc: "项目设置",
      action: () => navigate("settings/"),
    },
  ];

  return (
    <div className="flex flex-column w-full fadein animation-duration-500" style={{ alignItems: "center", paddingTop: 20, background: "linear-gradient(180deg, #f5f3ff 0%, #ffffff 100%)", minHeight: "100%" }}>
      {/* Project header */}
      <div style={{ marginBottom: 28, textAlign: "center" }}>
        <h1 style={{ margin: 0, fontSize: "1.5rem", fontWeight: 600, color: "#1e293b" }}>
          🏠 {project?.projectName || "Project"}
        </h1>
        <div style={{ display: "flex", gap: 12, marginTop: 6, fontSize: "0.85rem", color: "#64748b", justifyContent: "center" }}>
          {project?.currentStage && (
            <span style={{ background: "#e0e7ff", color: "#4338ca", padding: "2px 10px", borderRadius: 12, fontWeight: 500 }}>
              Stage: {project.currentStage}
            </span>
          )}
          {project?.status && (
            <span style={{
              background: project.status === "Active" ? "#dcfce7" : "#fef2f2",
              color: project.status === "Active" ? "#16a34a" : "#ef4444",
              padding: "2px 10px", borderRadius: 12, fontWeight: 500,
            }}>
              {project.status}
            </span>
          )}
        </div>
      </div>

      {/* Navigation cards - 2 rows x 3 cols */}
      <div className="flex flex-column">
        <div className="flex justify-content-center gap-3 mb-3">
          {cards.slice(0, 3).map((card) => (
            <div key={card.title} className="flex" onClick={() => card.action?.()}
              style={{ cursor: card.action ? "pointer" : "default", opacity: card.action ? 1 : 0.6 }}>
              <Card title={card.title} subTitle={card.subtitle} style={{ width: "18em" }}
                header={null}>
                <p className="p-m-0" style={{ lineHeight: "1.5" }}>
                  {card.icon} {card.desc} {card.action && <i className="pi pi-arrow-right"></i>}
                </p>
              </Card>
            </div>
          ))}
        </div>
        <div className="flex justify-content-center gap-3">
          {cards.slice(3, 6).map((card) => (
            <div key={card.title} className="flex" onClick={() => card.action?.()}
              style={{ cursor: card.action ? "pointer" : "default", opacity: card.action ? 1 : 0.6 }}>
              <Card title={card.title} subTitle={card.subtitle} style={{ width: "18em" }}
                header={null}>
                <p className="p-m-0" style={{ lineHeight: "1.5" }}>
                  {card.icon} {card.desc} {card.action && <i className="pi pi-arrow-right"></i>}
                </p>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default observer(ProjectHome);
